import { render, staticRenderFns } from "./DiseaseTrendChart.vue?vue&type=template&id=2c6b732e&scoped=true"
import script from "./DiseaseTrendChart.vue?vue&type=script&lang=js"
export * from "./DiseaseTrendChart.vue?vue&type=script&lang=js"
import style0 from "./DiseaseTrendChart.vue?vue&type=style&index=0&id=2c6b732e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b732e",
  null
  
)

export default component.exports